import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import app from './modules/app'
import user from './modules/userData'
import payment from './modules/payment'
import tariffs from './modules/tariffs'
import tv from './modules/tv'
import messages from './modules/messages'
import bonuses from './modules/bonuses'
import profile from './modules/profile'
import sales from './modules/sales'
import globalDialog from './modules/globalDialog'
import bill from './modules/bill'
import feedback from './modules/feedback'
import services from './modules/services'

Vue.use(Vuex)
const debug = process.env.VUE_APP_DEV_MODE === 'true'
const plugins = debug ? [createLogger({})] : []

const store = new Vuex.Store({
  modules: {
    app,
    user,
    payment,
    tariffs,
    tv,
    messages,
    bonuses,
    profile,
    sales,
    globalDialog,
    bill,
    feedback,
    services
  },
  plugins
})

export default store
